import { gql, QueryResult, useQuery } from "@apollo/client";

import {
  LabelTypeQueryInput,
  LabelTypeQueryResult,
} from "../../generated/gql/graphql";

const GET_LABEL_TYPES = gql`
  query LabelTypes($query: LabelTypeQueryInput) {
    labelTypes(query: $query) {
      items {
        name
        id
      }
      totalCount
      limit
      offset
      page
    }
  }
`;

export default function useLabelTypes(
  query?: LabelTypeQueryInput
): QueryResult<{ labelTypes: LabelTypeQueryResult }> {
  return useQuery(GET_LABEL_TYPES, {
    variables: {
      query,
    },
    fetchPolicy: "cache-and-network",
  });
}
